import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { TextFieldModule } from '@angular/cdk/text-field';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MarkdownModule } from 'ngx-markdown';
import { SharedModule } from 'src/app/shared/shared.module';
import { ChatbotComponent } from './components/chatbot/chatbot.component';
import { ChatbotEffects } from './effects/chatbot.effects';
import { featureAlioName, moduleAlioReducers } from './reducers';
import { ChatbotService } from './services/chatbot.service';

@NgModule({
  declarations: [ChatbotComponent],
  exports: [ChatbotComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    SharedModule,
    CommonModule,
    TextFieldModule,
    StoreModule.forFeature(featureAlioName, moduleAlioReducers),
    EffectsModule.forFeature([ChatbotEffects]),
    MarkdownModule,
  ],
  providers: [ChatbotService, provideHttpClient(withInterceptorsFromDi())],
})
export class AlioModule {}
